import { ComponentPropsWithRef } from "react";

export const MinusIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect x="7" y="11" width="10" height="2" fill="currentColor" />
  </svg>
);
